import { useEffect, useCallback } from "react";
import { partial, some } from "lodash";

// Hook
function useOnPressKey(keycode, refs, handler) {
  const matcher = useCallback(
    (event) => {
      if (Array.isArray(keycode)) {
        return some(keycode.map((keycode) => keycode === event.keyCode));
      } else {
        return keycode === event.keyCode;
      }
    },
    [keycode]
  );

  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if keypress is not in any ref's elements.
        if (refs) {
          for (let ref of refs) {
            if (!ref.current) {
              return;
            }
            if (ref.current.contains(event.target)) {
              break;
            }
          }
        } else {
          // Explicit, just to help understand. If there's no refs passed, this listener is on the entire document.
        }

        if (matcher(event)) {
          handler(event);
        }
      };

      document.addEventListener("keydown", listener);

      return () => {
        document.removeEventListener("keydown", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [refs, handler, matcher]
  );
}

export default useOnPressKey;

export const useOnPressEnter = partial(useOnPressKey, 13);
export const useOnPressTab = partial(useOnPressKey, 9);
